
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CPDueDiligenceDocumentsOverviewSkeletonLoader',
})
export default class CPDueDiligenceDocumentsOverviewSkeletonLoader extends Vue {}
